/* eslint-disable default-case */
export const placements = [
    'top-start',
    'top',
    'top-end',
    'bottom-start',
    'bottom',
    'bottom-end',
    'left-start',
    'left',
    'left-end',
    'right-start',
    'right',
    'right-end',
];
export default function calculatePosition(popup, anchor, placement, margin = 4) {
    if (!placements.includes(placement)) {
        throw new Error(`Invalid placement: ${placement}`);
    }
    const arrow = { x: 0, y: 0 };
    switch (placement) {
        case 'top-start':
        case 'bottom-start':
            popup.x = anchor.x;
            break;
        case 'top':
        case 'bottom':
            popup.x = anchor.x + anchor.width / 2 - popup.width / 2;
            break;
        case 'top-end':
        case 'bottom-end':
            popup.x = anchor.x + anchor.width - popup.width;
            break;
        case 'left-start':
        case 'left':
        case 'left-end':
            popup.x = anchor.x - popup.width - margin;
            break;
        case 'right-start':
        case 'right':
        case 'right-end':
            popup.x = anchor.x + anchor.width + margin;
            break;
    }
    switch (placement) {
        case 'top-start':
        case 'top':
        case 'top-end':
            popup.y = anchor.y - popup.height - margin;
            break;
        case 'bottom-start':
        case 'bottom':
        case 'bottom-end':
            popup.y = anchor.bottom + margin;
            break;
        case 'left-start':
        case 'right-start':
            popup.y = anchor.y;
            break;
        case 'left':
        case 'right':
            popup.y = anchor.y + anchor.height / 2 - popup.height / 2;
            break;
        case 'left-end':
        case 'right-end':
            popup.y = anchor.y + anchor.height - popup.height;
            break;
    }
    switch (placement) {
        case 'top-start':
        case 'top':
        case 'top-end':
            arrow.x = anchor.x + anchor.width / 2 - popup.x;
            arrow.y = popup.height;
            break;
        case 'bottom-start':
        case 'bottom':
        case 'bottom-end':
            arrow.x = anchor.x + anchor.width / 2 - popup.x;
            arrow.y = 0;
            break;
        case 'left-start':
        case 'left':
        case 'left-end':
            arrow.x = popup.width;
            arrow.y = anchor.y + anchor.height / 2 - popup.y;
            break;
        case 'right-start':
        case 'right':
        case 'right-end':
            arrow.x = 0;
            arrow.y = anchor.y + anchor.height / 2 - popup.y;
            break;
    }
    return { popup, arrow };
}
